import React from 'react';
import PropTypes from 'prop-types';

class BaseGrid extends React.Component {
  constructor(props) {
    super(props);
    App.Forms[props.entity] = App.Forms[props.entity] || {};
    App.Forms[props.entity].fields = {};
    this.state = {
      isRendered: false
    };
  }

  componentDidMount() {
    const {
      entity,
      tabName,
      isLookup,
      defaultColumns,
      customActions
    } = this.props;
    if (!isLookup) {
      Monet.Grid.generateIndexLayout(entity, tabName, { defaultColumns, customActions });
      this.renderGrid();
    }
  }

  componentDidUpdate() {
    this.renderGrid();
  }

  setCustomGridOptions = () => {
    const { customOptions, entity } = this.props;

    if (customOptions) {
      App.Forms[entity].customOptions = customOptions;
    }
  };

  setCustomGridCallbacks = () => {
    const { entity, gridCallbacks } = this.props;

    if (!gridCallbacks) return;

    for (const key in gridCallbacks) {
      const callback = gridCallbacks[key];

      App.Objects[entity][key] = callback;
    }
  };

  renderGrid() {
    const { entity, isLookup } = this.props;
    const { isRendered } = this.state;
    const router = App.Objects[entity];

    if (!isLookup && router && !isRendered) {
      this.setCustomGridOptions();
      this.setCustomGridCallbacks();

      router.list();

      this.setState({ isRendered: true });
    }
  }

  render() {
    const { entity, children } = this.props;
    return (
      <>
        <div data-testid={`${entity}Grid`} id={`${entity}Grid`} style={{ height: '100%' }} />
        {children}
      </>
    );
  }
}

BaseGrid.propTypes = {
  children: PropTypes.node.isRequired,
  entity: PropTypes.string.isRequired,
  tabName: PropTypes.string.isRequired,
  isLookup: PropTypes.bool,
  defaultColumns: PropTypes.arrayOf(PropTypes.string),
  customOptions: PropTypes.object,
  gridCallbacks: PropTypes.object
};

BaseGrid.defaultProps = {
  isLookup: false,
  defaultColumns: [],
  customOptions: null,
  gridCallbacks: null
};

export default BaseGrid;
